<template>
  <div id="userinfo">
    <h1>ユーザー情報</h1>
    <div class="info">
      <table>
        <tr>
          <th>名前</th><td>:</td><td>{{fullname}}</td>
          <!--編集する場合
          <th>名前</th><td>:</td><td><input type="text" v-model="fullname"></td>
        -->
        </tr>
        <tr>
          <th>カナ</th><td>:</td><td>{{kana}}</td>
          <!--編集する場合
          <th>カナ</th><td>:</td><td><input type="text" v-model="kana"></td>
        -->
        </tr>
        <tr>
          <th>ユーザー名(ID)</th><td>:</td><td><input type="text" v-model="user_name"></td>
        </tr>
        <tr>
          <th>mail</th><td>:</td><td><input type="text" v-model="mail_address"></td>
        </tr>
        <tr>
          <th>現在のパスワード</th><td>:</td><td><input type="password" v-model="current_password"></td>
        </tr>
        <tr>
          <th>新しいパスワード</th><td>:</td><td><input type="password" v-model="password"></td>
        </tr>
      </table>
    </div>
    <router-link tag="button" to="/Spuser" title="キャンセル" class="button">
      <span>キャンセル</span>
    </router-link><br>
    <input type="button" value="変更を適用" class="button" @click="Apply">
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'userinfo',
  deta () {
    return {
      user_id: null,
      fullname: null,
      kana: null,
      user_name: null,
      mail_address: null,
      password: null,
      current_fullname: null,
      current_kana: null,
      current_user_name: null,
      current_mail_address: null,
      current_password: null
    }
  },
  created () {
    this.user_id = this.$store.state.userInfo.user_id
    this.fullname = this.$store.state.userInfo.fullname
    this.kana = this.$store.state.userInfo.kana
    this.user_name = this.$store.state.userInfo.user_name
    this.mail_address = this.$store.state.userInfo.mail_address
    this.password = null
    this.current_fullname = this.$store.state.userInfo.fullname
    this.current_kana = this.$store.state.userInfo.kana
    this.current_user_name = this.$store.state.userInfo.user_name
    this.current_mail_address = this.$store.state.userInfo.mail_address
    this.current_password = null
  },
  methods: {
    ...mapActions([
      'changeFullname',
      'changeMailAddress',
      'changeUserName',
      'changeUserPassword'
    ]),
    checkKana () {
      if (!this.kana.match(/^[ァ-ヴ]+$/)) {
        return false
      }
      return true
    },
    Apply () {
      // カナの変更部分
      if (this.current_kana !== this.kana || this.current_fullname !== this.fullname) {
        if (!this.checkKana()) {
          alert('フリガナは全角カナのみで入力してください')
          return
        }
        this.changeFullname({
          id: this.user_id,
          newFullname: this.fullname,
          newKana: this.kana
        }).then((res) => {
          if (res) {
            this.$emit('changed')
            alert('氏名の変更に成功しました.')
          }
        })
      }
      if (this.current_mail_address !== this.mail_address) {
        this.changeMailAddress({
          id: this.user_id,
          newMailAddress: this.mail_address
        }).then((res) => {
          if (res) {
            this.$emit('ehanged')
            alert('変更に成功しました')
          }
        })
      }
      if (this.current_user_name !== this.user_name) {
        this.changeUserName({
          id: this.user_id,
          newUserName: this.user_name
        }).then((res) => {
          if (res) {
            this.$emit('changed')
            alert('ユーザ名の変更に成功しました.')
          }
        })
      }
      if (this.password !== null) {
        this.changeUserPassword({
          id: this.user_id,
          currentPassword: this.current_password,
          newPassword: this.password
        }).then((res) => {
          if (res) {
            alert('パスワードの変更に成功しました.')
          }
        })
      }
      this.$router.push('/Spuser')
    }
  }
}
</script>

<style scoped>
#userinfo{
  width: 100%;
  text-align: center;
}
h1{
  width: 80%;
  margin: auto;
  margin-top: 5px;
}
table{
  margin: auto;
  width: 90%;
}
.info{
  margin: auto;
  padding: 2vw;
  width: 90%;
  border: solid 2px rgb(255, 200, 6);
  border-radius: 7px;
}
.button{
  width: 50%;
  height: 10vh;
  margin: 10px;
  border: solid 3px rgb(255, 148, 6);
  border-radius: 5px;
  background-color: rgb(255, 214, 125);
  font-size:  7vw;
}
</style>



// WEBPACK FOOTER //
// Spchangeuserinfo.vue?5148cdd6